import React from 'react';
import { Phone, MessageCircle, Sparkles } from 'lucide-react';
import { trackPhoneClick, trackWhatsAppClick } from '../utils/tracking';

const WA_URL = `https://wa.me/918679333354?text=${encodeURIComponent('Hi! I would like a free quote for my wedding/event in Dharamshala.')}`;

const itemCls = 'flex-1 flex flex-col items-center justify-center gap-0.5 py-2 text-[11px] font-semibold tracking-wide active:scale-95 transition-transform';

export const MobileActionBar = () => (
  <nav
    className="sm:hidden fixed bottom-0 inset-x-0 z-[60] flex bg-white/95 backdrop-blur-md border-t border-[#efe3cf] shadow-[0_-6px_24px_rgba(0,0,0,0.08)]"
    style={{ paddingBottom: 'env(safe-area-inset-bottom)', fontFamily: "'Montserrat', sans-serif" }}
    data-testid="mobile-action-bar"
  >
    <a href="tel:+918679333354" onClick={trackPhoneClick} className={itemCls} style={{ color: '#8a6d3b' }} data-testid="mobile-bar-call">
      <Phone className="h-5 w-5" /> Call
    </a>
    <a href={WA_URL} target="_blank" rel="noopener noreferrer" onClick={trackWhatsAppClick} className={itemCls} style={{ color: '#128C7E' }} data-testid="mobile-bar-whatsapp">
      <MessageCircle className="h-5 w-5" /> WhatsApp
    </a>
    <button
      type="button"
      onClick={() => window.dispatchEvent(new CustomEvent('open-proposal'))}
      className={`${itemCls} text-white m-1.5 rounded-xl`}
      style={{ background: 'linear-gradient(135deg, #C9A96E, #B8943F)' }}
      data-testid="mobile-bar-quote"
    >
      <Sparkles className="h-5 w-5" /> Free Quote
    </button>
  </nav>
);
